module.exports = __webpack_public_path__ + "img/cp3-8.7873695c.jpg";